module.exports = __webpack_public_path__ + "static/media/logo-zh-tw.8152eeb5.png";